export default __webpack_public_path__ + "static/media/gwc-eth.02b16895.png";